<template>
  <div class="container-fluid mt-2">
    <h2 id="title">Auftragsparameter</h2>
    <div class="row">
      <div class="col-md">
        <div class="btn-toolbar justify-content-between" role="toolbar">
          <button @click="addField" class="btn btn-secondary">Neues Feld</button>
          <button @click="saveField" id="efsave" class="btn btn-primary">Speichern</button>
        </div>
        <div class="mt-3 container" id="list">
          <table class="table table-striped">
            <tbody>
              <tr @click="selectField(f)" v-for="f in fields" :key="f.map_id">
                <td>{{ f.name }}</td><td align="right"><button @click="deleteField(f,$event)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md" id="field">
        <b-tabs v-if="edit.name">
          <b-tab :title="'Feld: ' + edit.name">
            <div class="wrapper p-3 border">
              <div class="form-group">
                <label>Kennung:</label>
                <input v-model="edit.map_id" class="form-control" type="text"/>
              </div>
              <div class="form-group">
                <label>Bezeichnung:</label>
                <input v-model="edit.name" class="form-control" type="text"/>
              </div>
              <div class="form-group">
                <label>Datentyp:</label>
                <select class="form-control" v-model="edit.type" >
                  <option value=""></option>
                  <option value="0">Text</option>
                  <option value="1">Zahl</option>
                  <option value="8">Fließkommazahl</option>
                  <option value="2">Datum</option>
                  <option value="3">Auswahl</option>
                  <option value="7">Ja/Nein</option>
                  <option value="4">Bild</option>
                  <option value="5">NFC</option>
                  <option value="6">Unterschrift</option>
                </select>
              </div>
              <div class="form-check">
                <input id="reqfield" v-model="edit.required" class="form-check-input" type="checkbox"/>
                <label for="reqfield">Pflichtfeld</label>
              </div>
              <div class="form-check">
                <input id="hiddenfield" v-model="edit.hidden" class="form-check-input" type="checkbox"/>
                <label for="hiddenfield">Ausgeblendet</label>
              </div>
            </div>
          </b-tab>
          <b-tab title="Auswahlwerte">
            <div class="wrapper p-2">
              <div class="form-group">
                <label>Bezeichnung:</label>
                <input v-model="choiceName" id="oname" class="form-control" type="text"/>
              </div>
              <div class="form-group">
                <label>Wert:</label>
                <input v-model="choiceValue" id="ovalue" class="form-control" type="text"/>
              </div>
              <button @click="addSelectValue" id="addsel" class="btn btn-secondary">Hinzuf&uuml;gen</button>
              <div id="sellist" class="mt-4">
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th>Bezeichnung</th><th>Wert</th><th>Aktion</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(c,index) in edit.choices" :key="c.value">
                      <td>{{ c.name }}</td><td>{{ c.value }}</td><td><button @click="remSelectValue(index)" class="btn btn-danger"><font-awesome-icon icon="trash"/></button></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </b-tab>
          <b-tab title="Mehrsparchig">
            <div class="wrapper p-2">
              <div class="form-group">
                <label>Sprache:</label>
                <select class="form-control" id="llang" v-model="titleLang">
                  <option v-for="(val,key) in languages" :key="key" :value="key">{{ val }}</option>
                </select>
              </div>
              <div class="form-group">
                <label>Bezeichnung:</label>
                <input v-model="addTitle" class="form-control" id="lname" type="text"/>
              </div>
              <button @click="addLangLabel" class="btn btn-secondary">Hinzuf&uuml;gen</button>
              <div class="row mt-3">
              </div>
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Sprache</th>
                    <th>Bezeichnung</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(val,key) in this.edit.langs" :key="key">
                    <td>{{ key }}</td>
                    <td>{{ val }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-tab>
          <b-tab title="Regel">
            <AceEditor style="height:500px;" ref="rule" :lang="'javascript'" :editorId='"ruleEditor"' :content="edit.rule"/>
            <button @click="showExample" class="btn btn-secondary">Beispiel</button>
          </b-tab>
        </b-tabs>
      </div>
    </div>
    <b-modal id="showRuleExample" title="Beispiel" ok-only>
      <pre>
        // function name = 'param' + Map_id of the field
        // return value = json with a attribute value
        function paramMAPID(article,order,count,price) {
          if (count > 1000) {
            return { "value":"Super." };
          } else {
            return { "value":"Ask for more" };
          }
        }
      </pre>
    </b-modal>
  </div>
</template>

<script>
import extrafields from '@/modules/extrafields.js'
import AceEditor from '@/components/AceEditor.vue'

export default {
  name: 'iHandExtraFields',
  components: {
    AceEditor,
  },
  data() {
    return {
      target: 0,
      fields: [],
      edit: {},
      addTitle: '',
      titleLang: '',
      choiceName: '',
      choiceValue: '',
      languages: {
        de: "Deutsch",
        en: "Englisch"
      }
    }
  },
  created: function() {
    this.target = this.$route.params.type;
    this.fetchData();
  },
  methods: {
    fetchData: function() {
      var self = this;
      console.log(this.type);
      extrafields.list(this,this.target,function(data) {
        self.fields = data;
      })
    },
    deleteField: function(f,e) {
      console.log('delete field: ' + JSON.stringify(f));
      if (confirm('Feld: ' + f.map_id + ' wirklich löschen?')) {
        var self = this;
        extrafields.delete(this,f.map_id,function() {
          for (var i=self.fields.length;i--;) {
            if (self.fields[i] == f) {
              self.fields.splice(i,1);
              break;
            }
          }
          self.$forceUpdate();
        });
      }
      e.stopPropagation();
    },
    saveField: function() {
      if (!this.edit.map_id) {
        this.$bvToast.toast('Bitte zuerst ein Feld auswählen oder ein neues Feld mit einer Kennung erstellen.',{title:'Extrafelder',variant:'warning'});
        return;
      }
      console.log('save RULE: ' + this.$refs.rule.getContent());
      this.edit.target = this.target;
      this.edit.rule   = this.$refs.rule.getContent();
      console.log(JSON.stringify(this.edit));
      var self = this;
      extrafields.save(this,this.edit,function() {
        self.$bvToast.toast('Feld gespeichert.',{title:'Extrafelder',variant:'success'});
        self.fetchData();
      })
    },
    addSelectValue() {
      console.log('add selectvalue: ' + this.choiceName);
      if (!this.edit || !this.choiceName || !this.choiceValue) return;
      this.edit.choices = this.edit.choices || [];
      this.edit.choices.push({name: this.choiceName, value: this.choiceValue});
      this.$forceUpdate();
    },
    remSelectValue(idx) {
      console.log('rem sv: ' + idx);
      if (!this.edit) return;
      if (idx < 0 || idx >= this.edit.choices.length) return;
      this.edit.choices.splice(idx,1);
      this.$forceUpdate();
    },
    selectField: function(f) {
      console.log('select');
      this.edit = f;
    },
    addField: function() {
      this.edit = { name: 'NewField1' };
    },
    showExample: function() {
      console.log('show example');
      this.$bvModal.show('showRuleExample');
    },
    addLangLabel() {
      console.log('this. add lang')
      this.edit.langs = this.edit.langs || {};
      this.edit.langs[this.titleLang] = this.addTitle;
      this.$forceUpdate();
    }
  }
}
</script>
